<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MtrlAddMain from '@/views/MessageManagement/MtrlManage/TabChild/MtrlAddMain';
export default {
  name: 'MtrlAdd',
  components: {
    childTab1: MtrlAddMain
  },
  data() {
    return {
      activeName: 'first'
    };
  }
};
</script>

<style scoped></style>
